import * as posedetection from "@tensorflow-models/pose-detection";
import {GameBase} from "./GameBase";
import {AudioInput} from "../common/AudioInput";
import {SpriteAnimation} from "../common/SpriteAnimation";
import {SoundEffect} from "../common/SoundEffect";

const PHASE = {
  START: "START",
  CHARGE: "CHARGE",
  SHOOT: "SHOOT",
}
const DEFAULT_Z = 0.3
const urls = [
  'https://storage.googleapis.com/wcam-27caf.appspot.com/public/frame/04.png',
  'https://storage.googleapis.com/wcam-27caf.appspot.com/public/frame/05.png',
  'https://storage.googleapis.com/wcam-27caf.appspot.com/public/frame/06.png',
  'https://storage.googleapis.com/wcam-27caf.appspot.com/public/frame/07.png',
  'https://storage.googleapis.com/wcam-27caf.appspot.com/public/frame/08.png',
]
const url = "https://storage.googleapis.com/wcam-27caf.appspot.com/public/exp2_0.png"
const SPRITE_COL = 6
const SPRITE_ROW = 6
const SPRITE_FRAMES = SPRITE_COL * SPRITE_ROW

export class Mustang extends GameBase {
  constructor() {
    super();

    this.power = 0
    this.bulletPos = { x: 0, y: 0, z: DEFAULT_Z }
    this.vec = { x: 0, y: 5, z: 0 }
    this.poseMode = posedetection.SupportedModels.MoveNet
    // this.poseMode = posedetection.SupportedModels.BlazePose
    this.handMode = true
    this.phase = PHASE.START
    this.debug = ""
    this.voiceThreshold = 5
    this.coolDown = 0

    this.ready = false
    this.fires = []
    this.createFire(0,0) // preload

    this.audioInput = new AudioInput()

    this.lastTime = 0
    this.se = new SoundEffect('small_explosion1')

    // window.addEventListener("keydown", (event) => { this.handleKeydown(event) });
  }

  createFire(x, y) {
    return {
      sprite: new SpriteAnimation(urls[Math.floor(Math.random()*urls.length)], SPRITE_COL, SPRITE_ROW, 1.0),
      x,
      y,
      life: 0
    }
  }

  mainLoop({ pose, hands }) {
    if (this.coolDown > 0) {
      this.coolDown--
    }

    this.right = hands.find(h => h.handedness === "Left")

    if (!this.right || !this.right.keypoints3D) return
    const key = this.right.keypoints3D
    const key2D = this.right.keypoints
    const p1 = key[4]
    const p2 = key[12]
    let dist = Math.sqrt(
      (p1.x - p2.x) * (p1.x - p2.x) +
      (p1.y - p2.y) * (p1.y - p2.y) +
      (p1.z - p2.z) * (p1.z - p2.z)
    )
    if (dist <= 0.09) {
      this.ready = true
    }
    const now = new Date().getTime()
    if ((this.audioInput.volume > this.voiceThreshold || (this.ready && dist > 0.10))
      && this.fires.length < 50 && now - this.lastTime > 1000) {
      this.fires.push(this.createFire(key2D[4].x, key2D[4].y))
      // this.se.play()
      this.ready = false

      this.lastTime = now
    }

    // console.log(dist)
  }

  renderCamera(ctx, { pose, hands }) {
    this.fires.forEach(f => {
      f.sprite.render(ctx, {x:f.x, y:f.y}, 1.0 + 1.0 * f.life/SPRITE_FRAMES)
      f.life++
      if (f.life > SPRITE_FRAMES) {
        this.fires.splice(this.fires.indexOf(f), 1)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/game/Mustang.js